import React, { Suspense, lazy } from 'react';
import { ErrorBoundary } from './components/Error';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import AuthProvider from 'store/authContextProvider/AuthProvider';
import DashboardProvider from 'store/dashboardContextProvider/DashboardProvider';

const Header = lazy(() => import('./components/Header'));

const Authentication = lazy(() => import('./components/authentication'));
const Register = lazy(() => import('./components/register'));
const Dashboard = lazy(() => import('./components/dashboard/DashboardLayout'));
const NotFound = lazy(() => import('./components/Error/404'));

const Mock = lazy(() => import('./components/mock'));
const MockDeposit = lazy(() => import('./components/mock/MockDeposit'));
const MockFiatTransfer = lazy(
  () => import('./components/mock/MockFiatTransfer')
);

const App = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={<div />}>
          <AuthProvider>
            <DashboardProvider>
              <div className="mainApp animate__animated animate__fadeIn td-200">
                <Header />
                <Routes>
                  <Route path="/login" element={<Authentication />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/mock" element={<Mock />} />
                  <Route path="/mock/deposit" element={<MockDeposit />} />
                  <Route
                    path="/mock/transfer-fiat"
                    element={<MockFiatTransfer />}
                  />
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/*" element={<Dashboard />} />
                  <Route path="/404" element={<NotFound />} />
                </Routes>
              </div>
            </DashboardProvider>
          </AuthProvider>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
